<template>
  <div>
    <Loading v-bind:show="showLoadingButton">
      <md-content>
        <md-table v-model="searched" :md-sort="OrderBy" md-sort-order="desc" md-card @md-selected="onSelect" class="semMargin" items-per-page="5">
          <md-table-toolbar>

            <div class="md-layout md-gutter">
              <div class="md-layout-item" v-if="exibirCombo1 == true">
                <md-field>
                  <label for="combo1" class="color6361FB">{{detalhesCombo1.titulo}}</label>
                  <md-select v-model="combo1" name="combo1" id="combo1" @md-selected="changeCombo(combo1, 1)" class="filtro" style="color:#6361FB !important">
                    <md-option :value="c.value" v-for="c in detalhesCombo1.dados" :key="c.value" class="option">
                      {{c.text}}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item" v-if="exibirCombo2">
                <md-field>
                  <label for="combo1" class="color6361FB">{{detalhesCombo2.titulo}}</label>
                  <md-select name="combo2" id="combo2" v-model="combo2" @md-selected="changeCombo(combo2, 2)" class="filtro">
                    <md-option :value="c.value" v-for="c in detalhesCombo2.dados" :key="c.value" class="option">{{c.text}}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item" v-if="exibirCombo3">
                <md-field>
                  <label for="combo1" class="color6361FB">{{detalhesCombo3.titulo}}</label>
                  <md-select name="combo3" id="combo3" v-model="combo3" @md-selected="changeCombo(combo3, 3)" class="filtro">
                    <md-option :value="c.value" v-for="c in detalhesCombo3.dados" :key="c.value" class="option">{{c.text}}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>

            <div class="md-layout-item padding-pesquisar align-right">
              <md-field class="md-toolbar-section-end">
                <md-input placeholder="Pesquisar..." v-model="search" @input="searchOnTable" class="filtro color6361FB webkit-text-fill-color6361FB" />
                <button v-on:click="limparPesquisa" class="buttonLimpar">
                  <md-icon>backspace</md-icon>
                  <md-tooltip md-direction="top">Limpar pesquisa</md-tooltip>
                </button>
              </md-field>
            </div>

          </md-table-toolbar>

          <md-table-empty-state md-label="Nenhum resultado encontrado"
                                :md-description="`Nenhum registro encontrado. Tente pesquisar com outra informação.`">
          </md-table-empty-state>



          <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" md-selectable="single">
            <md-table-cell :md-label="c.Titulo" :md-sort-by="c.Field" :v-width="c.width" v-for="c in Header" :key="c.Field">

              <p class="s-h4 regular" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'texto'">{{item[c.Field]}}</p>

              <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'numero'">{{item[c.Field]}}</p>

              <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'date'" v-formatdate="item[c.Field]"></p>

              <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'dataTime'" v-formatdatetime="item[c.Field]"></p>

              <p class="s-h4 regular" style="text-align:center" v:tool :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'moeda'" v-formatmoeda="item[c.Field]"></p>

              <div md-label="c.Titulo" v-if="c.Tipo =='button'" width="30px">
                <md-tooltip md-direction="top">Exibir Termo ou Contrato</md-tooltip>
                <button v-on:click="CarregaTermoContrato(item[c.Field])" class="button"><md-icon>visibility</md-icon></button>
              </div>
            </md-table-cell>

          </md-table-row>
        </md-table>


        <div class="md-toolbar-section-start padding-20" v-if="Title">
          <p>{{Title}} ({{searched.length}})</p>
        </div>

        <div v-if="selected" class="padding-20" style="color:#fff">
          <p><strong>Linha selecionada:</strong></p>
          {{ selected }}
        </div>

        <md-dialog :md-active.sync="carregarTermosContrato" class="md-layout-item zindex md-dialog-size-100">
          <md-dialog-content>
            <md-dialog-actions class="divRight">
              <md-button class="md-primary" @click="carregarTermosContrato = false">Fechar</md-button>
            </md-dialog-actions>
            <div style="clear:both"></div>

            <div v-if="dadosTermoContrato" v-html="dadosTermoContrato" class="padding-md-dialog"></div>
            <pdf v-else-if="dadosTermoContratoPdf" :src="dadosTermoContratoPdf"></pdf>
          </md-dialog-content>
        </md-dialog>

      </md-content>
    </Loading>
  </div>

</template>

<script>

  import { formatdatetime } from '@/directives/formatdatetime.js';
  import { formatdate } from '@/directives/formatdate.js';
  import { formatmoeda } from '@/directives/formatmoeda.js';
  import Button from '@/services/ButtonService.js';
  import Termo from '@/services/TermoService.js'
  import Loading from '@/components/Loading';
  import pdf from 'vue-pdf';


  export default {

    name: 'Grid',
    components: {
      Loading,
      pdf
    },
    directives: {
      formatdatetime,
      formatdate,
      formatmoeda
    },
    props: {
      Data: {
        type: Array
      },
      Header: {
        type: Array
      },
      Name: String,
      Title: String,
      OrderBy: String,
      DetalhesCombo1: {
        type: Object
      },
      DetalhesCombo2: {
        type: Object
      },
      DetalhesCombo3: {
        type: Object
      }
    },
    data:
      function () {
        return {
          selected: null,
          aluno: null,
          dados: this.Data,
          dadosTermoContrato: null,
          dadosTermoContratoPdf: null,
          headers: this.Header,
          search: '',
          carregarTermosContrato: false,
          detalhesCombo1: this.DetalhesCombo1,
          detalhesCombo2: this.DetalhesCombo2,
          detalhesCombo3: this.DetalhesCombo3,
          exibirCombo1: false,
          exibirCombo2: false,
          exibirCombo3: false,
          valorPesquisaCombo: [],
          combo1: '',
          combo2: '',
          combo3: '',
          showLoadingButton: false
        }
      },

    methods: {

      getClass: () => ({
        'md-primary': 2
      }),
      onSelect(item) {
        this.selected = item;
      },
      limparPesquisa() {
        this.valorPesquisaCombo = [];
        this.combo1 = '';
        this.combo2 = '';
        this.combo3 = '';
        this.searched = this.dados;
        this.search = "";
      },

      changeCombo(valor, combo) {

        if (valor == "Todos") {

          var valorCombo1 = this.combo1;
          var valorCombo2 = this.combo2;
          var valorCombo3 = this.combo3;

          this.limparPesquisa();
          switch (combo) {
            case 1:
              if (valorCombo2 && valorCombo2 != "Todos") {
                this.valorPesquisadoCarregar(2, valorCombo2);
                this.combo2 = valorCombo2;
              }

              if (valorCombo3 && valorCombo3 != "Todos") {
                this.valorPesquisadoCarregar(3, valorCombo3);
                this.combo3 = valorCombo3;
              }
              break;

            case 2:
              if (valorCombo1 && valorCombo1 != "Todos") {
                this.valorPesquisadoCarregar(1, valorCombo1);
                this.combo1 = valorCombo1;
              }

              if (valorCombo3 && valorCombo3 != "Todos") {
                this.valorPesquisadoCarregar(3, valorCombo3);
                this.combo3 = valorCombo3;
              }
              break;

            case 3:
              if (valorCombo1 && valorCombo1 != "Todos") {
                this.valorPesquisadoCarregar(1, valorCombo1);
                this.combo1 = valorCombo1;
              }

              if (valorCombo2 && valorCombo2 != "Todos") {
                this.valorPesquisadoCarregar(2, valorCombo2);
                this.combo2 = valorCombo2;
              }
              break;
          }
        }
        else
          this.valorPesquisadoCarregar(combo, valor);

        this.searchOnTable();
      },

      valorPesquisadoCarregar(combo, valor) {
        if (this.valorPesquisaCombo.find(element => element.Combo == combo))
          this.valorPesquisaCombo.find(element => element.Combo == combo).Valor = valor.toString();
        else
          this.valorPesquisaCombo.push({ Combo: combo, Valor: valor.toString() });
      },

      searchOnTable() {

        this.searched = [];
        this.searched = this.dados;
        let valorAntigo = ''
        if (this.search) {
          valorAntigo = this.search;
          this.searched = this.dados.filter(contemTexto(this.search, this.headers));
        }

        if (this.valorPesquisaCombo.length > 0) {
          for (var i = 0; i < this.valorPesquisaCombo.length; i++) {
            this.search = this.valorPesquisaCombo[i].Valor;
            this.searched = this.searched.filter(contemTexto(this.search, this.headers));
          }

          this.search = valorAntigo;
        }
      },

      CarregaTermoContrato(codigoTermoContrato) {
        this.showLoadingButton = true;
        this.termoService.RecuperarConteudo(codigoTermoContrato).then(
          data => {
            if (data.ok) {
              this.carregarTermosContrato = true;

              switch (data.dados.mimeType) {
                case "text/html":
                  this.dadosTermoContratoPdf = null;
                  this.dadosTermoContrato = atob(data.dados.conteudo);
                  break;

                case "application/pdf":

                  var byteCharacters = atob(data.dados.conteudo);
                  var byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }

                  var byteArray = new Uint8Array(byteNumbers);

                  var blob = new Blob([byteArray], { type: data.dados.mimeType });


                  this.dadosTermoContrato = null;
                  this.dadosTermoContratoPdf = URL.createObjectURL(blob);

                  break;

                default:
                  this.$modal.info("Formato de termo/contrato desconhecido.");
              }

            }
            else {
              this.dadosTermoContrato = "";
              this.carregarTermosContrato = false;
              this.$modal.info(data.mensagem);
            }
          },
          error => {
            if (error.status != 500)
              this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            else
              this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
          }).finally(() => {
            this.showLoadingButton = false;
          });
      }
    },
    created() {
      //Verifica se tem aluno selecionado
      if (!sessionStorage.Aluno) {
        this.$router.push('home');
      }
      else {
        let a = JSON.parse(sessionStorage.Aluno);
        //Coloca o perfil de aluno disponível na variável aluno
        if (a.PerfilAluno) {
          this.aluno = a.PerfilAluno;
        }
        else
          this.$router.push('home');
      }

      this.buttonService = new Button(this);
      this.termoService = new Termo(this);

      this.searched = this.dados;
      if (this.detalhesCombo1 != null && this.detalhesCombo1.titulo != undefined) {
        this.combo1 = this.detalhesCombo1.dados[0].value;
        this.exibirCombo1 = true;
      }

      if (this.detalhesCombo2 != null && this.detalhesCombo2.titulo != undefined) {
        this.combo2 = this.detalhesCombo2.dados[0].value;
        this.exibirCombo2 = true;
      }

      if (this.detalhesCombo3 != null && this.detalhesCombo3.titulo != undefined) {
        this.combo3 = this.detalhesCombo3.dados[0].value;
        this.exibirCombo3 = true;
      }
    }
  }

  function contemTexto(search, headers) {
    return function (element) {

      for (var i = 0; i < headers.length; i++) {
        if (element[headers[i].Field] && element[headers[i].Field].toString().toLowerCase().includes(search.toLowerCase()))
          return true;
      }

      return false;
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .grid {
    width: 30em;
    overflow-x: auto;
    white-space: pre-wrap;
  }

  .theme-default {
    background-color: #9b9b9b;
    color: white;
  }

  .theme-primary {
    background-color: #448aff;
    color: white;
  }

  .theme-success {
    background-color: #009688;
    color: white;
  }

  .theme-danger {
    background-color: #ff5252;
    color: white;
  }

  .theme-warning {
    background-color: #f9aa33;
    color: white;
  }

  .align-right {
    float: right;
    padding: 20px;
  }

  .padding-20 {
    padding: 0 0 10px 20px;
  }

  .padding-pesquisar {
    padding: 0 0 0 30px;
  }


  .md-table-cell-container {
    padding: 0px;
  }

  .zindex {
    z-index: 1000;
  }

  .buttonLimpar {
    background-color: transparent;
    border: 0;
  }

  .filtro {
    height: 40px !important;
    font-size: 20px !important;
  }

  .color6361FB {
    color: #6361FB !important;
  }

  .option {
    background-color: #fff !important;
  }

    .option:hover {
      background-color: #6361FB !important;
    }

  .webkit-text-fill-color6361FB {
    -webkit-text-fill-color: #6361FB !important;
  }

  .border6361FB {
    border-bottom-color: #6361FB !important;
  }

  .semMargin {
    padding: 0 !important;
    margin: 0 !important;
  }

  .button {
    background-color: transparent;
    border: 0px;
  }

  .divLeft200 {
    width: 200px;
    float: left;
    position: relative;
    display: inline;
    padding: 5px 0 0 5px
  }

  .divRight {
    width: 100px;
    float: right;
    position: relative;
    display: inline;
    padding: 5px 0 0 5px
  }

  .md-icon-button:hover {
    background-color: darkgrey;
  }

  .padding-md-dialog {
    padding: 0px 20px 0px 20px;
  }
</style>
